import React from 'react';

function NoCarState() {
  return (
    <div className='noCarState'>
      <h2>Don’t see the car you’re looking for? Please modify the filters.</h2>
    </div>
  );
}

export default NoCarState;
